module.exports = __webpack_public_path__ + "img/escudo_alcaldia.958fea55.jpg";